<template lang="pug">
  div()
    app-header(:white='true' wrapper-class='u-bg-primary' class='u-bg-primary')

    progressive-background(:src='currentPost.imageUrl', :placeholder='currentPost.imageThumbUrl')

    article(class='o-wrapper o-container u-py5')
      h2(class='c-post__title u-fz-h3 u-mt0 u-mb3' data-aos='fade-up' ) {{currentPost.title}}
      p(class='u-mb0 u-capitalize u-fw-s-bold u-mb4 u-color-dark' data-aos='fade-up' ) {{currentPost.date}}
      div(v-html='currentPost.content' class='u-mb4' data-aos='fade-up' )

      p(class='u-uppercase u-border-top u-pt3 u-mt0' data-aos='fade-up' ) Compartir
      share-buttons(:shares="['facebook', 'gplus', 'linkedin']" data-aos='fade-up' )

    div(style='background-color:#f0f0f0;background-position: 0% 100%;background-image: url(/images/footer.png)' class='u-pt5 u-pb4' v-if='reports.length > 0')
      aside(class='o-wrapper o-container')
        p(class='u-uppercase u-color-dark u-fw-s-bold u-mt0' data-aos='fade-up' ) Más reportes

        section
          article(v-for='report in reports' class='c-post u-mb4' data-aos='fade-up' )
            div(class='u-p4')
              router-link(:to="{ name: 'Report', params:{slug: report.slug}}" class='c-post__title u-fz-h3') {{report.title}}
              div(v-html='report.content')
              p(class='')
                router-link(:to="{ name: 'Report', params:{slug: report.slug}}" class='u-color-secondary') Leer más...
              p(class='u-mb0 u-right-align u-capitalize u-color-dark u-fw-s-bold') {{report.date | date('short')}}
    app-footer
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'ReportScreen',
    data () {
      return {
        currentPost: false,
        reports: []
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      }),

      faceWeb () {
        // return `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(this.company.facebookPage)}&tabs=timeline&width=500&height=200&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
        return `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent('https://www.facebook.com/NoveltiePeru/')}&tabs=timeline&width=500&height=200&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
      }
    },

    methods: {
      getRelated () {
        axios.get(`${window.API_URL}/reports/last`)
          .then(({data}) => {
            this.reports = data.data
          })
      }
    },

    beforeRouteEnter (to, from, next) {
      axios.get(`${window.API_URL}/reports/${to.params.slug}`)
        .then(({data}) => {
          next((vm) => {
            vm.currentPost = data.data
          })
        })
        .catch(() => {
          next({name: 'NotFound'})
        })
    },

    watch: {
      currentPost (val) {
        this.getRelated()
      },

      $route (val, olVal) {
        axios.get(`${window.API_URL}/reports/${this.$route.params.slug}`)
          .then(({data}) => {
            this.currentPost = data.data
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Report/components/ReportScreen.vue